var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotificationIconDesktop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 14.5,
    r: 14,
    fill: "#00A898"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4092 11.5301C10.6408 9.44549 12.4028 7.86841 14.5002 7.86841V7.86841C16.5977 7.86841 18.3597 9.44549 18.5913 11.5301L18.7768 13.1999C18.872 14.0566 19.1508 14.8826 19.5943 15.6216L20.0202 16.3315C20.1961 16.6247 20.284 16.7712 20.3196 16.8842C20.4934 17.4369 20.1626 18.0212 19.5992 18.1565C19.484 18.1842 19.3131 18.1842 18.9712 18.1842H10.0292C9.68737 18.1842 9.51643 18.1842 9.4013 18.1565C8.8379 18.0212 8.50708 17.4369 8.6809 16.8842C8.71643 16.7712 8.80437 16.6247 8.98027 16.3315L9.40619 15.6216C9.84963 14.8826 10.1284 14.0566 10.2236 13.1999L10.4092 11.5301Z",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3652 18.4833C12.4912 19.0317 12.7687 19.5162 13.1547 19.8618C13.5408 20.2074 14.0138 20.3948 14.5004 20.3948C14.987 20.3948 15.46 20.2074 15.8461 19.8618C16.2321 19.5162 16.5097 19.0317 16.6356 18.4833",
    stroke: "white",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIconDesktop);
export default __webpack_public_path__ + "static/media/notification-icon-desktop.111e89811ea3e08bff36fd98b006354e.svg";
export { ForwardRef as ReactComponent };